import React, { Component } from 'react';
import $ from "jquery";
import axios from 'axios';
import DashboardHeading from '../commonFiles/DashboardHeading';
import ScheduleClientDetailsPopup from './ScheduleClientDetailsPopup';
import AddScheduleConsultation from './AddScheduleConsultation';
class ViewAllClients extends Component {
  constructor() {
    super();
    this.state = {
      all_table_row:'',
      open_popup:'',
      open_service_person:'',
    };
  }

  view_table_row(table_data){
    let cutThis = this;
    var all_table_row = [];
    var nu = 1;
    for(var data in table_data){
      var id                  = table_data[data]['id'];
      var first_name          = table_data[data]['first_name'];
      var last_name           = table_data[data]['last_name'];
      var email               = table_data[data]['email'];
      var mobile_no           = table_data[data]['mobile_no'];
      var user_type           = table_data[data]['user_type'];
      var added_date          = table_data[data]['added_date'];
      var status              = ['Inactive','Active','End'];

      var view_icon           = '';
      var change_service_per_icon = '';
      var add_info_icon = '';
      var add_schedule_icon = '';
      var dis_user_type = 'Free Consultation';
      if(user_type==3){
        add_info_icon = <span className="pointer" onClick={cutThis.open_service_client_details_popup.bind(cutThis,id,first_name,last_name)} title="Add Client Details"><i class="fas fa-folder-plus" aria-hidden="true"></i></span>;
        add_schedule_icon = <span className="pointer" onClick={cutThis.add_schedule_consultation.bind(cutThis,id,first_name,last_name)} title="Add Consultation"><i class="fas fa-calendar-plus" aria-hidden="true"></i></span>;
        dis_user_type = 'Schedule Consultation';
      }

      all_table_row.push(
        <tr id={nu}>
        <th scope="row">{nu}</th>
        <td>{first_name+" "+last_name}</td>
        <td>{email}</td>
        <td>{mobile_no}</td>
        <td>{dis_user_type}</td>
        <td>{added_date}</td>
        <td>{add_schedule_icon}</td>
        <td>{add_info_icon}</td>
        </tr>
      );
      nu++;
    }
    cutThis.setState({all_table_row});
  }




open_service_client_details_popup(id,first_name,last_name){
  var fullname = first_name+" "+last_name;
  var open_service_person = <ScheduleClientDetailsPopup fullname={fullname} emp_id={id}  close_popup_view={this.close_service_person_popup.bind(this)}/>;
  this.setState({open_service_person});
  setTimeout(function (){window.model_show();},100);
}


add_schedule_consultation(id,first_name,last_name){
  var fullname = first_name+" "+last_name;
  var open_service_person = <AddScheduleConsultation fullname={fullname} emp_id={id}  close_popup_view={this.close_service_person_popup.bind(this)}/>;
  this.setState({open_service_person});
  setTimeout(function (){window.model_show();},100);
}

close_service_person_popup(){
  window.model_hide();
  var open_service_person = '';
  this.setState({open_service_person});
  this.getFreeConsultation();
}


componentDidMount(){
  this.getFreeConsultation();
}
getFreeConsultation(){
    let cutThis = this;
    var web_token = $('#web_token').val();
     var body = new FormData();
     body.append('web_token',web_token);
     body.append('function','get_all_client_list_data');
     var url      = '';
     if(window.location.host ==="localhost:3000"){
       url = "http://localhost/bylawsindia/php/admin_free_consultation_url.php";
     }else{
       url = "/php/admin_free_consultation_url.php";
     }
     axios({
          method: 'POST',
          url: url,
          data: body
      })
      .then(function (res) {
        var data = res.data;
        console.log(data);
        if(data['code']==1){
          cutThis.view_table_row(data['msg']);
        }else{
          //window.location.href = '/';
        }

      })
      .catch(function (error) {
          console.log(error);
      });
}

  render() {
    return (
        <>
        <DashboardHeading title="Client List"/>
        	<div className="container mt-4 mb-4 Dashboard_main_div">
                <h3 className="wow fadeInUp" data-wow-delay="0.1s">Client List</h3>
                <div className="row g-4">
                <table class="table">
                <thead>
                <tr>
                <th scope="col">#</th>
                <th scope="col">Name</th>
                <th scope="col">Email</th>
                <th scope="col">Mobile</th>
                <th scope="col">Client Type</th>
                <th scope="col">Added Date</th>
                <th scope="col" colSpan="2">Action</th>
                </tr>
                </thead>
                <tbody>
                {this.state.all_table_row}
                </tbody>
                </table>

            </div>
        </div>
        {this.state.open_popup}
        {this.state.open_service_person}
        </>
    );
  }
}

export default ViewAllClients;
